/*
 * @Author: zhushitao
 * @Date: 2021-05-07 18:09:28
 * @LastEditors: zhushitao
 * @LastEditTime: 2021-11-23 10:42:35
 * @Description:
 */
import React from 'react';

export interface ErrorBoundaryProps {
  children?: React.ReactNode;
  errorRender?: React.ReactNode;
  appContext?: any;
}

export interface StateProps {
  hasError: boolean;
}

export default class ErrorBoundary extends React.Component<ErrorBoundaryProps> {
  state: StateProps = { hasError: false };

  static getDerivedStateFromError(error: Error): StateProps {
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    const { appContext } = this.props;
    console.error(error, errorInfo);
    appContext?.logger?.error?.('ErrorBoundaryError', {
      info: {
        ...error,
        ...errorInfo,
      },
    });
  }

  render() {
    const { errorRender, children } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return errorRender || <></>;
    }
    return children;
  }
}
